export default __webpack_public_path__ + "static/media/image.e754fe27.jpg";